import { render, staticRenderFns } from "./WavesConfigComponent.vue?vue&type=template&id=58a14110&"
import script from "./WavesConfigComponent.vue?vue&type=script&lang=js&"
export * from "./WavesConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports